<template>
  <v-card
    flat
    class="post-card"
    :style="{
      gridTemplateRows: p.media.length > 0 ? '100px 66px 34px' : 'auto 30px',
    }"
    style="
      position: relative;
      border: 1px solid hsl(214.3 31.8% 91.4%);
      border-radius: 0.5rem;
      box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
      display: grid;
      overflow: visible;
    "
    width="200"
    height="200"
    :id="`post-${p.uid}`"
    @click="loadPost(p.uid)"
  >
    <div v-if="p.media.length > 0">
      <div
        v-if="p.media[0]?.extension === 'pdf'"
        :ref="`pdfContainer-${p.uid}`"
        style="
          max-height: 100px;
          width: 200px;
          overflow: auto;
          position: relative;
        "
        class="hide-scrollbar"
      >
        <VuePdfEmbed
          :source="p.media[0]?.src"
          :page="1"
          @rendered="scrollPdfToCenter(p.uid)"
        />
      </div>
      <v-img v-else cover :aspect-ratio="16 / 9" :src="getSrc(p.media[0])">
        <v-chip
          size="small"
          color="white"
          style="position: absolute; bottom: 10%; left: 5%; opacity: 0.8"
          v-if="p.media.length > 1"
        >
          <v-icon class="mr-1" size="small">mdi-image</v-icon
          >{{ p.media.length }}
        </v-chip>
        <v-chip
          size="small"
          color="white"
          style="position: absolute; bottom: 10%; left: 5%; opacity: 0.8"
          v-if="p.media[0].type === 'video'"
        >
          <v-icon size="small">mdi-video</v-icon>
        </v-chip>
        <v-btn
          @click="openLink(p.media[0].url)"
          v-if="p.media[0] && p.media[0].type === 'url'"
          rounded
          color="smoke"
          size="small"
          style="position: absolute; bottom: 10%; left: 5%; opacity: 0.8"
          class="font-weight-regular"
          elevation="0"
          ><v-icon size="small">mdi-link</v-icon>
          <!-- <span
            style="
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 200px;
            "
            >{{ p.media[0].url }}</span
          > -->
        </v-btn></v-img
      >
    </div>

    <div class="pa-3">
      <p
        class="mb-0 line-clamp"
        style="font-size: 11pt; font-weight: 400"
        :style="{
          '-webkit-line-clamp': p.media.length > 0 ? 2 : 4,
        }"
      >
        {{ p.title || p.variations[0].text }}
      </p>
    </div>

    <div>
      <div v-if="p.status === 'suggested'">
        <v-chip
          size="small"
          variant="flat"
          label
          style="
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            width: 90%;
          "
          color="muted"
          class="ml-2 font-weight-medium px-3 d-flex justify-center"
          ><v-icon class="mr-2">mdi-creation</v-icon> AI Generated</v-chip
        >
      </div>
      <div
        v-if="p.status != 'suggested'"
        class="d-flex align-center px-3 justify-space-between"
        style="height: 100%; gap: 10px"
      >
        <div>
          <v-tooltip v-if="p.statistics">
            <template v-slot:activator="{ props }">
              <v-chip
                v-bind="props"
                color="smokeDark"
                size="x-small"
                label
                variant="flat"
              >
                {{ p.statistics?.engagementRate }}%
              </v-chip>
            </template>
            <div>
              <p class="text-white mb-1 font-weight-medium">Statistics</p>
              <p class="text-white">
                {{ p.statistics?.engagementRate }}% engagement rate
              </p>
              <p class="text-white">{{ p.statistics?.likes }} likes</p>
              <p class="text-white">{{ p.statistics?.comments }} comments</p>
              <p class="text-white">{{ p.statistics?.shares }} shares</p>
              <p class="text-white">
                {{ p.statistics?.impressions }} impressions
              </p>
              <p class="text-white">{{ p.statistics?.clicks }} clicks</p>
              <p class="text-white">
                {{ p.statistics?.uniqueImpressions }} unique impressions
              </p>
            </div>
          </v-tooltip>
          <v-tooltip
            :text="
              p.recurring
                ? 'Click to change to one-time.'
                : 'Click to change to recurring.'
            "
          >
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" icon variant="text" size="x-small">
                <v-icon
                  @click.stop="
                    $store.dispatch('changeRecurring', {
                      recurring: p.recurring,
                      post: p.uid,
                    })
                  "
                  color="primary"
                  size="15"
                  >{{
                    p.recurring
                      ? "mdi-infinity"
                      : "mdi-numeric-1-circle-outline"
                  }}</v-icon
                >
              </v-btn>
            </template>
          </v-tooltip>
          <v-icon
            size="small"
            v-if="p.media[0]?.extension === 'pdf'"
            color="faded"
            >mdi-file-pdf-box</v-icon
          >
        </div>
        <v-tooltip
          :text="
            p.status === 'active'
              ? 'Click to change to draft.'
              : 'Click to change to active.'
          "
        >
          <template v-slot:activator="{ props }">
            <v-chip
              @click.stop="
                $store.dispatch('changeStatus', {
                  status: p.status,
                  post: p.uid,
                })
              "
              :disabled="!p.category"
              variant="flat"
              size="x-small"
              label
              v-bind="props"
              :color="p.status === 'active' ? 'success' : 'info'"
              class="primary--text font-weight-medium"
            >
              <v-icon size="12" class="mr-1">{{
                p.status === "active" ? "mdi-play" : "mdi-pause"
              }}</v-icon>
              {{ p.status.charAt(0).toUpperCase() + p.status.slice(1) }}</v-chip
            >
          </template>
        </v-tooltip>
      </div>
    </div>
  </v-card>
</template>

<script>
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { post } from "@/mixins/post";
import VuePdfEmbed from "vue-pdf-embed";
export default {
  mixins: [post],
  props: {
    p: {
      type: Object,
    },
  },
  components: {
    VuePdfEmbed,
  },
  methods: {
    async deletePost() {
      let r = window.confirm("Are you sure to delete this post?");
      if (!r) {
        return;
      }
      this.$store.commit("setLoading", { type: "general", val: true });
      const deletePost = httpsCallable(functions, "postDelete");
      await deletePost(this.p.uid);
      this.$store.commit("deletePost", this.p.uid);
      this.$store.dispatch("fetchCategories");
      this.$store.dispatch("getCalendarDays");
      this.$store.commit("setLoading", { type: "general", val: false });
      this.$store.commit("setNotification", {
        show: true,
        text: "Your post has been deleted!",
        type: "primary",
        icon: "delete",
      });
    },
    scrollPdfToCenter(uid) {
      this.$nextTick(() => {
        const container = this.$refs[`pdfContainer-${uid}`];
        if (container) {
          const scrollHeight = container.scrollHeight;
          const containerHeight = container.clientHeight;
          // Scroll to center (halfway through the content)
          container.scrollTop = (scrollHeight - containerHeight) / 2;
        }
      });
    },
    getSrc(media) {
      if (media.thumbnail?.src) {
        return media.thumbnail.src;
      } else if (media.thumbnail) {
        return media.thumbnail;
      } else {
        return media.src;
      }
    },
    openLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.post-card {
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;
}

.post-card:hover {
  transform: translateY(-2px);
}

.cap {
  overflow: hidden;
  max-width: 240px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ai-suggested-bg {
  position: relative;
  background: linear-gradient(120deg, #202124, #1f4b8c, #6f2dbd, #202124);
  background-size: 300% 300%;
  animation: aiFlow 8s ease-in-out infinite;
  color: #f5f5f5;
}

@keyframes aiFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
